import { graphql } from 'react-relay';
import { ToolType } from '../types';
import { aiStudioImageModelsQuery$data } from './__generated__/aiStudioImageModelsQuery.graphql';

export const AiStudioImageModelsQuery = graphql`
    query aiStudioImageModelsQuery {
        aiStudioImageModels {
            toolType
            serviceID
            model
            allowedAspectRatios
        }
    }
`;

export type AIStudioImageModel = aiStudioImageModelsQuery$data['aiStudioImageModels'][number];
type AIStudioImageToolType = AIStudioImageModel['toolType'];

// Maps the frontend tool ids to the backend AIStudioToolType enum values exposed by aiStudioImageModels.
// Only the image-edit tools that support aspect ratio selection are listed.
const IMAGE_TOOL_TYPE_BY_TOOL_ID: Partial<Record<ToolType, AIStudioImageToolType>> = {
    'virtual-tryon': 'VIRTUAL_TRY_ON',
    'product-staging': 'PRODUCT_STAGING',
    'multi-image-fusion': 'MULTI_IMAGE_FUSION',
    'ad-generator': 'AD_GENERATOR'
};

/** Returns the aspect ratios the backend allows for a given tool, or an empty list when the tool has none. */
export function getAspectRatiosForTool(models: readonly AIStudioImageModel[], toolId: ToolType): readonly string[] {
    const toolType = IMAGE_TOOL_TYPE_BY_TOOL_ID[toolId];
    if (!toolType) return [];
    return models.find((m) => m.toolType === toolType)?.allowedAspectRatios ?? [];
}
